// extracted by mini-css-extract-plugin
export default {"container":"PlatformDocuments_container__74uMG","link":"PlatformDocuments_link__oU9Ms","arrow":"PlatformDocuments_arrow__7+KLl"};